// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Table_wrapper__3dRQc","table":"Table_table__2qCqI","row":"Table_row__2hWQf","col":"Table_col__30lDR","tooltip":"Table_tooltip__2oM_e"};